import { DI } from '../../../../apps/crossword-maker/src/shared/di';
import {
	ICrosswordBookApiRequestData,
	ICrosswordBookApiResponse
} from '../../Api/CrosswordBook/CrosswordBook.api.types';

export const GetManyCrosswordBookWordsUseCase = () => {
	const CrosswordBookRepository = DI.resolve('CrosswordBookRepository');

	return {
		async execute(data?: ICrosswordBookApiRequestData): Promise<ICrosswordBookApiResponse> {
			return await CrosswordBookRepository.getManyWords(data);
		}
	}
}
